export default __webpack_public_path__ + "static/media/full4.3265e0c2.jpg";